import { api } from "@/redux/api";

import {
	HelpConversationDetail,
	HelpConversationDetailSchema,
	HelpConversationListArgs,
	HelpConversationPage,
	HelpConversationPageSchema,
	SetHelpFeedbackArgs,
} from "./helpConversations.schema";

/**
 * Conversation persistence endpoints: the GLOBAL_ADMIN support-review list/detail, and the
 * end-user answer-feedback mutation (also used by the in-app chat widget).
 */
export const helpConversationsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getHelpConversations: builder.query<HelpConversationPage, HelpConversationListArgs>({
			query: ({ page, limit, searchValue, language, feedback, createdFrom, createdTo }) => ({
				url: "help-center/admin/conversations",
				params: { page, limit, searchValue, language, feedback, createdFrom, createdTo },
				responseSchema: HelpConversationPageSchema,
			}),
			providesTags: ["HelpConversations"],
		}),
		getHelpConversation: builder.query<HelpConversationDetail, number>({
			query: (id) => ({
				url: `help-center/admin/conversations/${id}`,
				responseSchema: HelpConversationDetailSchema,
			}),
			providesTags: ["HelpConversations"],
		}),
		setHelpFeedback: builder.mutation<void, SetHelpFeedbackArgs>({
			query: ({ messageId, feedback }) => ({
				url: `help-center/conversations/messages/${messageId}/feedback`,
				method: "PATCH",
				body: { feedback },
			}),
		}),
	}),
});

export const {
	useGetHelpConversationsQuery,
	useGetHelpConversationQuery,
	useSetHelpFeedbackMutation,
} = helpConversationsApi;
